import { LANGUAGE_CN } from '@home/_config/config';
import { IAreaType, ICountryType, IGenreSource } from "../typings";
import { AreaItemtype, CountryItemType } from '@/pages/intelligence/components/Filter/util';
import { getDataSourceIcon } from '@/pages/intelligence/utils/getDataSourceImg';
import { CUT_TAG, CUT_TAG_VALUES, CUT_TAG_VALUES_CN } from '@intelligence/components/GenreSelectMiddleware/Supports/constants';


/**
   * @description: 格式化百分比，超出99999%限制输出为99999%+
   * @param {Number||String} num
   * @return {String}
   */
export const formatPercentNum = (num: string | number) => {
  if (!num) return '0';
  if(typeof num !== 'number') return num;
  let _num = Number(num);
  let _percentage = 0;
  if (Math.abs(_num) > 0 && Math.abs(_num) < 0.01) {
      // 四舍五入保留两位小数
      _percentage = Number((Math.round(Math.abs(_num) * 10000) / 100).toFixed(2));
  } else {
      _percentage = Math.abs(Math.round((_num) * 100));
  }
  return _percentage > 99999 ? '99999%+' : _percentage + '%';
}

/**
 * 格式化regions筛选器的数据
 * @param _list region接口中返回的数据列表
 * @returns 适合regions筛选器使用的数据
 */
export const regionFormatter = ((_list: IAreaType[]): AreaItemtype[] => {
  return _list?.map((item: IAreaType): AreaItemtype => {
    const { continent, subcontinent, country_set = [] } = item || {};
    return {
      area_code: continent,
      area_name_en: subcontinent,
      area_name_ch: subcontinent,
      country_set: country_set?.map((countryItem: ICountryType): CountryItemType => {
        const { abbre, name } = countryItem || {};
        return {
          country_code: abbre,
          country_name_en: name,
          country_name_ch: name,
          deviation: ''
        }
      })
    }
  })
});

// 获取环比值
export const getRatio = (type: 'normal' | 'hashMark',curValue: any, lastValue: any) => {
  switch (type) {
    // 值为排名的列
    case 'hashMark':
      if (!curValue || !lastValue) return '-';
      const dValue = curValue - lastValue;
      if (dValue === 0) return '=';
      return curValue - lastValue;
    default:
      if (!curValue && !lastValue) return null;
      // 今年没有去年有，下降100%
      if (!curValue && lastValue) return null;
      // 今年有，去年没有，上升100%
      if (curValue && !lastValue) return null;
      return (curValue - lastValue) / lastValue;
  }
};

export const getPlatformList = (_platformStr: string) => {
  if (!_platformStr) return [];
  const platformMap: any = {
    xbox: 'xbox',
    ps: 'playstation',
    nintendo: 'nintendo'
  }
  const tmpArr: string[] = [];
  (_platformStr.split('|') || []).forEach((key: string) => {
    if (key) {
      const transKey = platformMap[key.toLowerCase()] || '';
      tmpArr.push(getDataSourceIcon(transKey));
    }
  });
  return tmpArr;
};

// 转换annie为appannie，原因是组件中的值为annie，接口的值为appannie
export const transGenreSource = (sourceName: IGenreSource) => {
  if (sourceName === 'annie') return 'appannie';
  return sourceName;
};

/**
 * 搜索关键字，做快捷转换，比如输入soc，要转换为Open World Survival Craft 进行搜索
 * 1、匹配上了快捷搜索，就返回快捷搜索配置的关键字
 * 2、没匹配上，就原样返回
 * @param keywords 搜索输入的关键字
 * @returns 做了快捷搜索转换后的关键字
 */
export const getSearchKeywordsWithCutTag = (locale: string, keywords: string): string => {
  const cutTagValues = locale === LANGUAGE_CN ? CUT_TAG_VALUES_CN : CUT_TAG_VALUES;
  const keywords1 = keywords?.trim() || '';
  const keywords2 = keywords1?.toUpperCase() || '';
  if (!CUT_TAG.includes(keywords2)) return keywords1;
  return cutTagValues?.[keywords2] || keywords1;
};
